import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../services/auth.jsx'

export default function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(username, password)
      navigate('/')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #052e16 0%, #14532d 60%, #166534 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ textAlign: 'center', width: '100%', maxWidth: 400, padding: '0 24px' }}>
        <div style={{ fontSize: 52, marginBottom: 8 }}>🌾</div>
        <div style={{ fontSize: 12, letterSpacing: '0.2em', color: '#86efac', fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>
          Faz. Fortaleza
        </div>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: '#fff', marginBottom: 4 }}>Planejamento Verão</h1>
        <p style={{ color: '#86efac', marginBottom: 40, fontSize: 14 }}>Entre com suas credenciais</p>

        <form onSubmit={handleSubmit} style={{
          background: 'rgba(255,255,255,0.07)',
          backdropFilter: 'blur(12px)',
          border: '1.5px solid rgba(255,255,255,0.15)',
          borderRadius: 20, padding: 32,
        }}>
          {error && (
            <div style={{
              background: '#fee2e2', color: '#7f1d1d', borderRadius: 10,
              padding: '10px 14px', marginBottom: 20, fontSize: 13, fontWeight: 600,
            }}>{error}</div>
          )}

          {[
            { label: 'Usuário', value: username, set: setUsername, type: 'text', placeholder: 'admin, operador ou dono' },
            { label: 'Senha',   value: password, set: setPassword, type: 'password', placeholder: '••••••••' },
          ].map(({ label, value, set, type, placeholder }) => (
            <div key={label} style={{ marginBottom: 16, textAlign: 'left' }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#86efac', marginBottom: 6, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                {label}
              </label>
              <input
                type={type}
                value={value}
                onChange={e => set(e.target.value)}
                placeholder={placeholder}
                required
                style={{
                  width: '100%', padding: '12px 16px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '1.5px solid rgba(255,255,255,0.2)',
                  borderRadius: 10, color: '#fff', fontSize: 15,
                  outline: 'none', fontFamily: 'inherit',
                }}
              />
            </div>
          ))}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '14px',
              background: loading ? '#4ade80' : '#16a34a',
              border: 'none', borderRadius: 12,
              color: '#fff', fontSize: 15, fontWeight: 800,
              cursor: loading ? 'not-allowed' : 'pointer',
              marginTop: 8, letterSpacing: '0.02em',
            }}
          >
            {loading ? 'Entrando...' : 'Entrar →'}
          </button>
        </form>
      </div>
    </div>
  )
}
